module.exports = __webpack_public_path__ + "img/user.b0d5a864.svg";